var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500.1 500",
    style: {
      enableBackground: "new 0 0 500.1 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4F5666;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500.1,250c-0.3,138.7-111.8,250.1-250.2,250C111.1,499.9-0.1,388.1,0,249.8C0.1,111.7,111.3,0,250.2,0 C388.6,0,499.8,111.6,500.1,250z M378.4,280.8c-23.1-23.3-46.1-46.3-69.2-69.6c22.9-22.9,45.9-46,69-69c-0.4,0-0.8,0-1.3,0 c-13.5,0-27,0-40.4,0c-0.9,0-1.5,0.3-2.2,0.9c-12.6,12.6-25.2,25.3-37.8,37.9c-9.8,9.9-19.7,19.7-29.6,29.6 c-0.3,0.3-0.7,0.7-1.1,1.2c0.3,0.2,0.6,0.4,0.8,0.6c22.6,22.6,45.2,45.2,67.9,67.8c0.4,0.4,1.2,0.7,1.8,0.7c13.6,0,27.1,0,40.7,0 C377.4,280.8,377.8,280.8,378.4,280.8z M191.1,211.7c-23.1,23.1-46.1,46.1-69,69c0,0,0.2,0,0.4,0c13.8,0,27.6,0,41.4,0 c0.5,0,1.2-0.3,1.6-0.7c3.4-3.4,6.8-6.8,10.3-10.2c19.1-19.1,38.2-38.2,57.3-57.3c0.3-0.3,0.6-0.6,1.1-1.2c-0.4-0.3-0.8-0.6-1.2-0.9 c-10.3-10.3-20.6-20.7-31-31c-12.2-12.2-24.4-24.4-36.6-36.6c-0.4-0.4-1.1-0.7-1.7-0.7c-13.6,0-27.3,0-40.9,0 c-0.3,0-0.6,0.1-0.9,0.1c-0.1,0.1-0.2,0.2-0.2,0.3C144.8,165.5,167.8,188.5,191.1,211.7z M249.6,361.1c-1.7,0.1-3.7,0.2-5.8,0.3 c-7.6,0.6-15.1,2-22.3,4.6c-12,4.4-22.6,10.8-31.8,19.8c-3.4,3.3-4.8,8.2-3,12.7c2.2,5.6,8.2,8.6,14,7c2.4-0.7,4.1-2.2,5.8-3.8 c6.9-6.4,14.7-11.3,23.7-14.2c10.9-3.6,21.9-4.1,33-1.8c8,1.7,15.5,4.7,22.1,9.5c3.4,2.5,6.6,5.4,9.9,8.1c3.6,3,7.7,3.5,11.9,1.7 c7.6-3.3,9.3-13.4,3.3-19.1c-4-3.8-8.3-7.4-13-10.5C283.1,366,267.2,361.4,249.6,361.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Icon);
export default __webpack_public_path__ + "static/media/404_ICON.9e1a4db28d2f2fa80556855d8ec7a823.svg";
export { ForwardRef as ReactComponent };